module.exports = __webpack_public_path__ + "static/media/nexusbar_logo.52de2b70.png";